/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, themeStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LOADER : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	loader: {
		display: 'inline-block',
		position: 'relative',
		width: pxToEm(64),
		height: pxToEm(64),
		'& div': {
			boxSizing: 'border-box',
			display: 'block',
			position: 'absolute',
			width: pxToEm(51),
			height: pxToEm(51),
			margin: pxToEm(6),
			border: replacePXinStringWithEM(`6px solid #fff`),
			borderRadius: '50%',
			animation: 'lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
			borderColor: `#fff transparent transparent transparent`,
			'&:nth-child(1)': { animationDelay: '-0.45s' },
			'&:nth-child(2)': { animationDelay: '-0.3s' },
			'&:nth-child(3)': { animationDelay: '-0.15s' },
		},

		// ----- colors ----- //
		// generates classes for every color in the theme ".color-(uniqueColor)"
		extend: themeStyleHelper(theme, 'color', (theme, uniqueColor) => {
			return {
				'& div': { borderTopColor: theme.color[uniqueColor].medium.swatch }
			}
		})
	},
	'@global': {
		'@keyframes lds-ring': {
			'0%': {
				transform: 'rotate(0deg)'
			},
			'100%': {
				transform: 'rotate(360deg)'
			}
		}
	}
});